/*
 * @Author: cjw 
 * @Date: 2021-03-30 17:25:19 
 * @Last Modified by: cjw
 * @Last Modified time: 2021-09-06 10:42:55
 */

import { ProxyChanges } from './proxy/proxy-changes'
import { ProxyDictionary } from './proxy/proxy-dictionary'
import { ProxyFilter } from './proxy/proxy-filter'
import { ProxyPosition } from './proxy/proxy-position'

// 数据表
export function DataTable(target, options) {

    const meta = {
        options: options
    }

    let observed = target

    // 由于 target 可能是已代理的对象（DataTable 支持镶嵌），所以通过是否支持 acceptChanges 方法进行判断
    // 数据日志代理如果已存在则不需要再进行代理（通过是否存在 acceptChanges 方法识别）
    if (!observed.acceptChanges) {
        observed = new ProxyChanges(observed, meta.options)
    }
    // 数据字典代理如果已存在则不需要再进行代理（通过是否存在 primaryKey 属性识别）
    if (!observed.primaryKey) {
        // 存在一个先后问题，因为数据字典可能会对数据进行处理（例如小数点位数限制），
        // 所以应该让 ProxyDictionary 处理完数据后再由 ProxyChanges 记录修改日志
        observed = new ProxyDictionary(observed, meta.options)
    }
    // 代理数据过滤功能（可以多级过滤）
    observed = new ProxyFilter(observed, meta.options)
    // 代理当前行功能（每个 DataTable 对象可以拥有自己的当前行，互不影响）
    observed = new ProxyPosition(observed, meta.options)

    return observed
}